import type { SplitObject } from './geos';
import type { PlacingToShadowtrack, Read } from './prediction';
import type { User as _User } from './users';

export type User = _User;

export type LatLngPoint = {
  lat: number;
  lng: number;
  elv?: number;
};

export type DeltaLatLng = {
  dLat: number;
  dLng: number;
};

type LatLngTimePoint = LatLngPoint & {
  time: Date;
};

export type Point = LatLngTimePoint & {
  elv?: number;
  receivedAt?: Date;
};

export type AppIdWithPoints = {
  appId: string;
  points: Array<Point>;
};

type TrackIdWithPoints = {
  trackId: string;
  points: Array<Point>;
};

export type PointWithOffset = LatLngTimePoint & {
  offset: number;
};

export type TracksData = {
  tracks: Array<AppIdWithPoints | TrackIdWithPoints>;
};

/**
 * @deprecated Legacy type
 */
export type Splits = Array<SplitObject>;

export enum TypeOfSource {
  RRForwarder = 'RRForwarder',
  RRExporter = 'RRExporter',
  RacemapReadsAPI = 'RacemapReadsAPI',
}

export enum ReadVariants {
  HasBeenSelectedToBeTheStartRead = 'HasBeenSelectedToBeTheStartRead',
  HasBeenSelectedToBeTheFinishRead = 'HasBeenSelectedToBeTheFinishRead',
  HasBeenCalculatedToBeTheFinishRead = 'HasBeenCalculatedToBeTheFinishRead',
  ThisReadClosesTheSearchForAStartRead = 'ThisReadClosesTheSearchForAStartRead',
  Unclassified = 'Unclassified',
  Rejected = 'Rejected',
  Regular = 'Regular',
  Unused = 'Unused',
}

export type ShadowTrackMapping = {
  lat: number;
  lng: number;
  elv?: number;
  offset: number;
  distance: number;
};

export type Reader = {
  name?: string;
  readerId: string;
  lastRead: Read;
  location?: {
    lat: number;
    lng: number;
    elv?: number;
  };
  receivedAt: string;
  readsCount: number;
  placing: PlacingToShadowtrack;
  mappings: Array<ShadowTrackMapping>;
  subReaderIds?: Array<string>;
};
